package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets21 {
  internal val names_14_yechezkel_29_txt: AssetResource by lazy { init_names_14_yechezkel_29_txt() }

  internal val names_14_yechezkel_30_txt: AssetResource by lazy { init_names_14_yechezkel_30_txt() }

  internal val names_14_yechezkel_31_txt: AssetResource by lazy { init_names_14_yechezkel_31_txt() }

  internal val names_14_yechezkel_32_txt: AssetResource by lazy { init_names_14_yechezkel_32_txt() }

  internal val names_14_yechezkel_35_txt: AssetResource by lazy { init_names_14_yechezkel_35_txt() }

  internal val names_14_yechezkel_38_txt: AssetResource by lazy { init_names_14_yechezkel_38_txt() }

  internal val names_14_yechezkel_39_txt: AssetResource by lazy { init_names_14_yechezkel_39_txt() }

  internal val names_14_yechezkel_txt: AssetResource by lazy { init_names_14_yechezkel_txt() }

  internal val names_15_hoshea_01_txt: AssetResource by lazy { init_names_15_hoshea_01_txt() }

  internal val names_15_hoshea_txt: AssetResource by lazy { init_names_15_hoshea_txt() }

  internal val names_16_yoel_txt: AssetResource by lazy { init_names_16_yoel_txt() }

  internal val names_17_amos_07_txt: AssetResource by lazy { init_names_17_amos_07_txt() }

  internal val names_17_amos_txt: AssetResource by lazy { init_names_17_amos_txt() }

  internal val names_18_ovadia_txt: AssetResource by lazy { init_names_18_ovadia_txt() }

  internal val names_19_yona_txt: AssetResource by lazy { init_names_19_yona_txt() }

  internal val names_1_bereshit_01_txt: AssetResource by lazy { init_names_1_bereshit_01_txt() }

  internal val names_1_bereshit_02_txt: AssetResource by lazy { init_names_1_bereshit_02_txt() }

  internal val names_1_bereshit_03_txt: AssetResource by lazy { init_names_1_bereshit_03_txt() }

  internal val names_1_bereshit_04_txt: AssetResource by lazy { init_names_1_bereshit_04_txt() }

  internal val names_1_bereshit_05_txt: AssetResource by lazy { init_names_1_bereshit_05_txt() }

  internal val names_1_bereshit_06_txt: AssetResource by lazy { init_names_1_bereshit_06_txt() }

  internal val names_1_bereshit_11_txt: AssetResource by lazy { init_names_1_bereshit_11_txt() }

  internal val names_1_bereshit_14_txt: AssetResource by lazy { init_names_1_bereshit_14_txt() }

  internal val names_1_bereshit_15_txt: AssetResource by lazy { init_names_1_bereshit_15_txt() }

  internal val names_1_bereshit_21_txt: AssetResource by lazy { init_names_1_bereshit_21_txt() }

  internal val names_1_bereshit_23_txt: AssetResource by lazy { init_names_1_bereshit_23_txt() }

  internal val names_1_bereshit_26_txt: AssetResource by lazy { init_names_1_bereshit_26_txt() }

  internal val names_1_bereshit_29_txt: AssetResource by lazy { init_names_1_bereshit_29_txt() }

  internal val names_1_bereshit_30_txt: AssetResource by lazy { init_names_1_bereshit_30_txt() }

  internal val names_1_bereshit_32_txt: AssetResource by lazy { init_names_1_bereshit_32_txt() }

  internal val names_1_bereshit_34_txt: AssetResource by lazy { init_names_1_bereshit_34_txt() }

  internal val names_1_bereshit_35_txt: AssetResource by lazy { init_names_1_bereshit_35_txt() }

  internal val names_1_bereshit_36_txt: AssetResource by lazy { init_names_1_bereshit_36_txt() }

  internal val names_1_bereshit_37_txt: AssetResource by lazy { init_names_1_bereshit_37_txt() }

  internal val names_1_bereshit_38_txt: AssetResource by lazy { init_names_1_bereshit_38_txt() }

  internal val names_1_bereshit_43_txt: AssetResource by lazy { init_names_1_bereshit_43_txt() }

  internal val names_1_bereshit_45_txt: AssetResource by lazy { init_names_1_bereshit_45_txt() }

  internal val names_1_bereshit_46_txt: AssetResource by lazy { init_names_1_bereshit_46_txt() }

  internal val names_1_bereshit_47_txt: AssetResource by lazy { init_names_1_bereshit_47_txt() }

  internal val names_1_bereshit_48_txt: AssetResource by lazy { init_names_1_bereshit_48_txt() }

  internal val names_1_bereshit_49_txt: AssetResource by lazy { init_names_1_bereshit_49_txt() }

  internal val names_1_bereshit_50_txt: AssetResource by lazy { init_names_1_bereshit_50_txt() }

  internal val names_1_bereshit_txt: AssetResource by lazy { init_names_1_bereshit_txt() }

  internal val names_20_micha_01_txt: AssetResource by lazy { init_names_20_micha_01_txt() }

  internal val names_20_micha_txt: AssetResource by lazy { init_names_20_micha_txt() }

  internal val names_21_nachum_txt: AssetResource by lazy { init_names_21_nachum_txt() }

  internal val names_22_havakuk_txt: AssetResource by lazy { init_names_22_havakuk_txt() }

  internal val names_23_tzefania_01_txt: AssetResource by lazy { init_names_23_tzefania_01_txt() }

  internal val names_23_tzefania_txt: AssetResource by lazy { init_names_23_tzefania_txt() }

  internal val names_24_haggai_txt: AssetResource by lazy { init_names_24_haggai_txt() }

  internal fun values(): List<AssetResource> = listOf(names_14_yechezkel_29_txt,
      names_14_yechezkel_30_txt, names_14_yechezkel_31_txt, names_14_yechezkel_32_txt,
      names_14_yechezkel_35_txt, names_14_yechezkel_38_txt, names_14_yechezkel_39_txt,
      names_14_yechezkel_txt, names_15_hoshea_01_txt, names_15_hoshea_txt, names_16_yoel_txt,
      names_17_amos_07_txt, names_17_amos_txt, names_18_ovadia_txt, names_19_yona_txt,
      names_1_bereshit_01_txt, names_1_bereshit_02_txt, names_1_bereshit_03_txt,
      names_1_bereshit_04_txt, names_1_bereshit_05_txt, names_1_bereshit_06_txt,
      names_1_bereshit_11_txt, names_1_bereshit_14_txt, names_1_bereshit_15_txt,
      names_1_bereshit_21_txt, names_1_bereshit_23_txt, names_1_bereshit_26_txt,
      names_1_bereshit_29_txt, names_1_bereshit_30_txt, names_1_bereshit_32_txt,
      names_1_bereshit_34_txt, names_1_bereshit_35_txt, names_1_bereshit_36_txt,
      names_1_bereshit_37_txt, names_1_bereshit_38_txt, names_1_bereshit_43_txt,
      names_1_bereshit_45_txt, names_1_bereshit_46_txt, names_1_bereshit_47_txt,
      names_1_bereshit_48_txt, names_1_bereshit_49_txt, names_1_bereshit_50_txt,
      names_1_bereshit_txt, names_20_micha_01_txt, names_20_micha_txt, names_21_nachum_txt,
      names_22_havakuk_txt, names_23_tzefania_01_txt, names_23_tzefania_txt, names_24_haggai_txt)
}

private fun init_names_14_yechezkel_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-29.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-29.txt")

private fun init_names_14_yechezkel_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-30.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-30.txt")

private fun init_names_14_yechezkel_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-31.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-31.txt")

private fun init_names_14_yechezkel_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-32.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-32.txt")

private fun init_names_14_yechezkel_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-35.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-35.txt")

private fun init_names_14_yechezkel_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-38.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-38.txt")

private fun init_names_14_yechezkel_39_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel-39.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel-39.txt")

private fun init_names_14_yechezkel_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_14_yechezkel.txt\")") as String, rawPath =
    "peopleNames/names_14_yechezkel.txt")

private fun init_names_15_hoshea_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_15_hoshea-01.txt\")") as String, rawPath =
    "peopleNames/names_15_hoshea-01.txt")

private fun init_names_15_hoshea_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_15_hoshea.txt\")") as String, rawPath =
    "peopleNames/names_15_hoshea.txt")

private fun init_names_16_yoel_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_16_yoel.txt\")") as String, rawPath =
    "peopleNames/names_16_yoel.txt")

private fun init_names_17_amos_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_17_amos-07.txt\")") as String, rawPath =
    "peopleNames/names_17_amos-07.txt")

private fun init_names_17_amos_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_17_amos.txt\")") as String, rawPath =
    "peopleNames/names_17_amos.txt")

private fun init_names_18_ovadia_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_18_ovadia.txt\")") as String, rawPath =
    "peopleNames/names_18_ovadia.txt")

private fun init_names_19_yona_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_19_yona.txt\")") as String, rawPath =
    "peopleNames/names_19_yona.txt")

private fun init_names_1_bereshit_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-01.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-01.txt")

private fun init_names_1_bereshit_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-02.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-02.txt")

private fun init_names_1_bereshit_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-03.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-03.txt")

private fun init_names_1_bereshit_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-04.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-04.txt")

private fun init_names_1_bereshit_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-05.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-05.txt")

private fun init_names_1_bereshit_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-06.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-06.txt")

private fun init_names_1_bereshit_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-11.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-11.txt")

private fun init_names_1_bereshit_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-14.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-14.txt")

private fun init_names_1_bereshit_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-15.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-15.txt")

private fun init_names_1_bereshit_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-21.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-21.txt")

private fun init_names_1_bereshit_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-23.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-23.txt")

private fun init_names_1_bereshit_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-26.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-26.txt")

private fun init_names_1_bereshit_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-29.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-29.txt")

private fun init_names_1_bereshit_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-30.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-30.txt")

private fun init_names_1_bereshit_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-32.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-32.txt")

private fun init_names_1_bereshit_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-34.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-34.txt")

private fun init_names_1_bereshit_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-35.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-35.txt")

private fun init_names_1_bereshit_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-36.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-36.txt")

private fun init_names_1_bereshit_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-37.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-37.txt")

private fun init_names_1_bereshit_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-38.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-38.txt")

private fun init_names_1_bereshit_43_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-43.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-43.txt")

private fun init_names_1_bereshit_45_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-45.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-45.txt")

private fun init_names_1_bereshit_46_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-46.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-46.txt")

private fun init_names_1_bereshit_47_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-47.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-47.txt")

private fun init_names_1_bereshit_48_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-48.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-48.txt")

private fun init_names_1_bereshit_49_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-49.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-49.txt")

private fun init_names_1_bereshit_50_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit-50.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit-50.txt")

private fun init_names_1_bereshit_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_1_bereshit.txt\")") as String, rawPath =
    "peopleNames/names_1_bereshit.txt")

private fun init_names_20_micha_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_20_micha-01.txt\")") as String, rawPath =
    "peopleNames/names_20_micha-01.txt")

private fun init_names_20_micha_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_20_micha.txt\")") as String, rawPath =
    "peopleNames/names_20_micha.txt")

private fun init_names_21_nachum_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_21_nachum.txt\")") as String, rawPath =
    "peopleNames/names_21_nachum.txt")

private fun init_names_22_havakuk_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_22_havakuk.txt\")") as String, rawPath =
    "peopleNames/names_22_havakuk.txt")

private fun init_names_23_tzefania_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_23_tzefania-01.txt\")") as String, rawPath =
    "peopleNames/names_23_tzefania-01.txt")

private fun init_names_23_tzefania_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_23_tzefania.txt\")") as String, rawPath =
    "peopleNames/names_23_tzefania.txt")

private fun init_names_24_haggai_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_24_haggai.txt\")") as String, rawPath =
    "peopleNames/names_24_haggai.txt")

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_29_txt: AssetResource
  get() = CommonMainAssets21.names_14_yechezkel_29_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_30_txt: AssetResource
  get() = CommonMainAssets21.names_14_yechezkel_30_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_31_txt: AssetResource
  get() = CommonMainAssets21.names_14_yechezkel_31_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_32_txt: AssetResource
  get() = CommonMainAssets21.names_14_yechezkel_32_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_35_txt: AssetResource
  get() = CommonMainAssets21.names_14_yechezkel_35_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_38_txt: AssetResource
  get() = CommonMainAssets21.names_14_yechezkel_38_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_39_txt: AssetResource
  get() = CommonMainAssets21.names_14_yechezkel_39_txt

public actual val SharedRes.assets.peopleNames.names_14_yechezkel_txt: AssetResource
  get() = CommonMainAssets21.names_14_yechezkel_txt

public actual val SharedRes.assets.peopleNames.names_15_hoshea_01_txt: AssetResource
  get() = CommonMainAssets21.names_15_hoshea_01_txt

public actual val SharedRes.assets.peopleNames.names_15_hoshea_txt: AssetResource
  get() = CommonMainAssets21.names_15_hoshea_txt

public actual val SharedRes.assets.peopleNames.names_16_yoel_txt: AssetResource
  get() = CommonMainAssets21.names_16_yoel_txt

public actual val SharedRes.assets.peopleNames.names_17_amos_07_txt: AssetResource
  get() = CommonMainAssets21.names_17_amos_07_txt

public actual val SharedRes.assets.peopleNames.names_17_amos_txt: AssetResource
  get() = CommonMainAssets21.names_17_amos_txt

public actual val SharedRes.assets.peopleNames.names_18_ovadia_txt: AssetResource
  get() = CommonMainAssets21.names_18_ovadia_txt

public actual val SharedRes.assets.peopleNames.names_19_yona_txt: AssetResource
  get() = CommonMainAssets21.names_19_yona_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_01_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_01_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_02_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_02_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_03_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_03_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_04_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_04_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_05_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_05_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_06_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_06_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_11_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_11_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_14_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_14_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_15_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_15_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_21_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_21_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_23_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_23_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_26_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_26_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_29_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_29_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_30_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_30_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_32_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_32_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_34_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_34_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_35_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_35_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_36_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_36_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_37_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_37_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_38_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_38_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_43_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_43_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_45_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_45_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_46_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_46_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_47_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_47_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_48_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_48_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_49_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_49_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_50_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_50_txt

public actual val SharedRes.assets.peopleNames.names_1_bereshit_txt: AssetResource
  get() = CommonMainAssets21.names_1_bereshit_txt

public actual val SharedRes.assets.peopleNames.names_20_micha_01_txt: AssetResource
  get() = CommonMainAssets21.names_20_micha_01_txt

public actual val SharedRes.assets.peopleNames.names_20_micha_txt: AssetResource
  get() = CommonMainAssets21.names_20_micha_txt

public actual val SharedRes.assets.peopleNames.names_21_nachum_txt: AssetResource
  get() = CommonMainAssets21.names_21_nachum_txt

public actual val SharedRes.assets.peopleNames.names_22_havakuk_txt: AssetResource
  get() = CommonMainAssets21.names_22_havakuk_txt

public actual val SharedRes.assets.peopleNames.names_23_tzefania_01_txt: AssetResource
  get() = CommonMainAssets21.names_23_tzefania_01_txt

public actual val SharedRes.assets.peopleNames.names_23_tzefania_txt: AssetResource
  get() = CommonMainAssets21.names_23_tzefania_txt

public actual val SharedRes.assets.peopleNames.names_24_haggai_txt: AssetResource
  get() = CommonMainAssets21.names_24_haggai_txt
